import { Serializable } from "./serializable";

export default class Relationship implements Serializable<Relationship> {
  id: string = "";
  _type: string = "";

  deserialize(input: any): Relationship {
    if (input != null) {
      this.id = input.id;
      this._type = input._type || null;
    }
    return this;
  }
}
